import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Theme
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import useRouter from 'use-react-router';
import { TableEditBar } from '../../../components/TableEditBar';
import { User } from '../../../graphql/auth';
import { PaginatiorInfo } from '../../../graphql/common.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
  },
  content: {
    padding: 0
  },
  inner: {
    [theme.breakpoints.up('md')]: {
      minWidth: 700,
    },
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1)
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end'
  },
}));

const Results = (props: {
  className?: string,
  users: User[],
  paginatorInfo?: PaginatiorInfo,
  setPage?: (page: number) => void,
  rowsPerPage?: number,
  setRowsPerPage?: (rowsPerPage: number) => void,
  selectedUser?: User,
  setSelectedUser: (user: User) => void,
  title?: string
  actionTitle?: string,
  action?: (userId: number) => void
  actionIgnoreIds?: number[]
}) => {
  const {className, rowsPerPage, setPage, setRowsPerPage, paginatorInfo, selectedUser, setSelectedUser, users, title, action, actionTitle} = props;
  const actionIgnoreIds = props.actionIgnoreIds ? props.actionIgnoreIds : [];
  const classes = useStyles();
  const {history} = useRouter();

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
    if (setPage) setPage(page + 1);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (setRowsPerPage) setRowsPerPage(Number(event.target.value));
  };

  return (
    <div
      className={clsx(classes.root, className)}
    >
      <Card>
        <CardHeader
          title={title ? title : 'Users'}
        />
        <Divider/>
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>First Name</TableCell>
                    <TableCell>Last Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map(user => {
                    return (
                      <TableRow
                        hover
                        key={user.id}
                        selected={selectedUser === user}
                      >
                        <TableCell onClick={() => history.push('/users/' + user.id)}>{user.first_name}</TableCell>
                        <TableCell onClick={() => history.push('/users/' + user.id)}>{user.last_name}</TableCell>
                        <TableCell onClick={() => history.push('/users/' + user.id)}>{user.email}</TableCell>
                        <TableCell align="right">
                          {action && actionIgnoreIds.indexOf(user.id) === -1 && (
                            <Button
                              color="primary"
                              size="small"
                              variant="outlined"
                              onClick={() => action(user.id)}
                            >
                              {actionTitle}
                            </Button>
                          )}
                        </TableCell>

                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        {paginatorInfo && rowsPerPage && (
          <CardActions className={classes.actions}>
            <TablePagination
              component="div"
              count={paginatorInfo.total}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              page={paginatorInfo.currentPage - 1}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[25, 50, 100]}
            />
          </CardActions>
        )}
      </Card>
      <TableEditBar selected={[]}/>
    </div>
  );
};

export default Results;
